import { Time } from 'interfaces/time';

// timestamp strings
export default function (d1ts: string, d2ts?: string): Time {
  const d1 = new Date(d1ts);
  const d2 = d2ts ? new Date(d2ts) : new Date();
  const diff = (d2.getTime() > d1.getTime() ? d2.getTime() - d1.getTime() : d1.getTime() - d2.getTime()) / 1000;
  const minutes = Math.floor(diff / 60);
  const seconds = Math.round(diff % 60);

  return {
    minutes: Math.abs(minutes),
    seconds: Math.abs(seconds),
  };
}
